/** EncycGames launch blog placeholders — replace titles/body when final copy is ready. */

export interface EncycGamesBlogPost {
  slug: string;
  title: string;
  date: string;
  excerpt: string;
  tags: string[];
  body: string[];
}

export const ENCYCGAMES_BLOGS_PLACEHOLDER = true;

export const ENCYCGAMES_BLOGS: EncycGamesBlogPost[] = [
  {
    slug: 'why-encycgames',
    title: '[Placeholder] Why EncycGames: clearer sports development',
    date: '2026-09-01',
    excerpt: 'Sample launch post — replace with final EncycGames product story.',
    tags: ['Product', 'Launch', 'Placeholder'],
    body: [
      'PLACEHOLDER: EncycGames helps athletes, parents, and coaches see Foundation readiness before expensive contest cycles.',
      'PLACEHOLDER: Lean path — benchmarks, learn, self evaluation (with coach/parent feedback when possible), then contest videos.',
      'PLACEHOLDER: Leaderboards exist for recognition; they are not the reason to rush submission.',
    ],
  },
  {
    slug: 'lean-contest-prep',
    title: '[Placeholder] Lean contest process: Self Evaluation before video submit',
    date: '2026-09-02',
    excerpt: 'Sample post — self-eval first, ready gate, then browse/submit.',
    tags: ['Contests', 'Parents', 'Placeholder'],
    body: [
      'PLACEHOLDER: Contest upload is gated behind completed Self Evaluation for the selected age.',
      'PLACEHOLDER: After self-eval, confirm “Are you ready?” — you may still submit if grades are low.',
      'PLACEHOLDER: Coach/parent notes are encouraged; without a coach, thorough self-eval still unlocks contest.',
    ],
  },
  {
    slug: 'foundation-benchmarks',
    title: '[Placeholder] Foundation benchmarks and Boy/Girl bands',
    date: '2026-09-03',
    excerpt: 'Sample post — certification-style grade bands vs ranking scales.',
    tags: ['Benchmarks', 'Placeholder'],
    body: [
      'PLACEHOLDER: Foundation grades guide practice against clear bands.',
      'PLACEHOLDER: Benchmark tables show Boy/Girl (or Male/Female) rows; Self Eval/Contest use a gender filter.',
      'PLACEHOLDER: Use Benchmark and Learn freely; Contest submit is the proof step after prep.',
    ],
  },
  {
    slug: 'schools-and-academies',
    title: '[Placeholder] Schools and academies: contests as exams',
    date: '2026-09-04',
    excerpt: 'Sample post — institutional use of Foundation contests.',
    tags: ['Schools', 'Academies', 'Placeholder'],
    body: [
      'PLACEHOLDER: Regular School and Sports Academy registration support shared exams across ages.',
      'PLACEHOLDER: Contests-as-exams encourages prep quality over medal chasing.',
      'PLACEHOLDER: Motor, psychomotor, and fitness pages help align PE language across sports.',
    ],
  },
  {
    slug: 'parents-coach-role',
    title: '[Placeholder] Parents and coaches: feedback that improves the next session',
    date: '2026-09-05',
    excerpt: 'Sample post — coach/parent notes over rushing the leaderboard.',
    tags: ['Parents', 'Coaches', 'Placeholder'],
    body: [
      'PLACEHOLDER: Ask coaches to review self-eval values and leave notes when available.',
      'PLACEHOLDER: Low self-eval grades are information, not a hard block after completion.',
      'PLACEHOLDER: EncycGames lowers the cost of learning what to practice next.',
    ],
  },
];

export function getBlogBySlug(slug: string): EncycGamesBlogPost | undefined {
  return ENCYCGAMES_BLOGS.find((b) => b.slug === slug);
}
